/**
 * Design Tokens - Main Export
 * Auto-generated from Figma Design System: Crop Circle System
 *
 * This file exports all design tokens for use throughout the application.
 * Tokens provide a single source of truth for design decisions.
 *
 * @example
 * ```tsx
 * import { tokens } from '@/shared-ui/tokens';
 *
 * const MyComponent = () => (
 *   <View style={{
 *     backgroundColor: tokens.colors.orange[500],
 *     padding: tokens.spacing.lg,
 *     borderRadius: tokens.borderRadius.pill,
 *   }}>
 *     <Text style={tokens.typography.body.medium}>
 *       Hello World
 *     </Text>
 *   </View>
 * );
 * ```
 */

import { colors } from './colors';
import { typography, fontFamilies, fontWeights, fontSizes, lineHeights } from './typography';
import { spacing, componentSpacing, layout, BASE_SPACING } from './spacing';
import { borderRadius, componentBorderRadius } from './borderRadius';
import { shadows, blur, componentShadows, getShadowStyle } from './shadows';

export { colors, type ColorToken, type ColorPath } from './colors';
export {
  typography,
  fontFamilies,
  fontWeights,
  fontSizes,
  lineHeights,
  type TypographyToken,
  type TypographyCategory,
} from './typography';
export {
  spacing,
  componentSpacing,
  layout,
  BASE_SPACING,
  type SpacingToken,
  type SpacingKey,
} from './spacing';
export {
  borderRadius,
  componentBorderRadius,
  type BorderRadiusToken,
  type BorderRadiusKey,
} from './borderRadius';
export {
  shadows,
  blur,
  componentShadows,
  getShadowStyle,
  type ShadowToken,
  type ShadowKey,
  type BlurToken,
  type BlurKey,
} from './shadows';

/**
 * All tokens combined
 * Convenience export for accessing all tokens from a single object
 */
export const tokens = {
  colors,
  typography,
  spacing,
  borderRadius,
  shadows,
  blur,
  componentSpacing,
  componentBorderRadius,
  componentShadows,
  layout,
} as const;

/**
 * Design System Metadata
 */
export const designSystem = {
  name: 'Crop Circle System',
  version: '1.0.0',
  figmaFileId: 'knAFKgkS8wkIQ47XbZAe4S',
  figmaUrl: 'https://www.figma.com/design/knAFKgkS8wkIQ47XbZAe4S/Crop-Circle-System',
  lastUpdated: new Date().toISOString(),
} as const;
